// Enterprise Access Log Model
export class EnterpriseAccessLog {
  constructor(data = {}) {
    this.id = data.id || null;
    this.userId = data.userId || null;
    this.userEmail = data.userEmail || '';
    this.userFirstName = data.userFirstName || '';
    this.userLastName = data.userLastName || '';
    this.enterpriseId = data.enterpriseId || null;
    this.action = data.action || '';
    this.metadata = data.metadata || {};
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
  }

  get userFullName() {
    const firstName = this.userFirstName || '';
    const lastName = this.userLastName || '';
    return `${firstName} ${lastName}`.trim() || this.userEmail;
  }
}